import { render, staticRenderFns } from "./132.vue?vue&type=template&id=206daf7a&scoped=true&"
var script = {}
import style0 from "./132.vue?vue&type=style&index=0&id=206daf7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206daf7a",
  null
  
)

export default component.exports